export default "__VITE_ASSET__DnMlOhO0__"